import React from "react";

const ContactsPage = () => {

    return (
        <div className="contacts-page-container">
            <div className="contacts-heading">Contact</div>

            <div className="contact-block">
                <div className="map">
                    <iframe
                        title="IIT BBS Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31686.11142881267!2d85.67558713007811!3d20.145028348176187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909bb453fe9c5%3A0x4c2bdcf238e3e61f!2sIndian%20Institute%20of%20Technology%20Bhubaneswar!5e0!3m2!1sen!2sin!4v1697046650984!5m2!1sen!2sin&zoom=32"
                        width="400"
                        height="500"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                </div>

                <div className="contact-info">
                    <h2>Address</h2>
                    <p><strong>Dr Debi Prosad Dogra</strong></p>
                    <p>Associate Professor (Computer Science and Engineering) & HoD</p>
                    <p>Room Number 115</p>
                    <p>School of Electrical & Computer Sciences</p>
                    <p>IIT Bhubaneswar</p>
                    <p>Argul, Jatni, Khordha, Odisha 752050, India</p>
                    <p>Email: <a href="mailto:dpdogra@iitbbs.ac.in">dpdogra@iitbbs.ac.in</a>, <a href="mailto:debiprosadcom@gmail.com">debiprosadcom@gmail.com</a></p>
                    <p>Phone Number (Work): +91-674-713-5716</p>
                </div>
            </div>

            <div className="copyright">
                &copy; All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
            </div>
        </div>
    );
};

export default ContactsPage;